import {useEffect} from 'react'
import WhitePlus from '../../../../../../media/felsv/white_plus-small_icon.svg'
import WhiteCheck from '../../../../../../media/felsv/white_check_icon.svg'
import DarkPorcentaje from '../../../../../../media/felsv/Porcentaje.svg'
import SecondaryPorcentaje from '../../../../../../media/felsv/PorcentajeSecondary.svg'
import DarkDollar from '../../../../../../media/felsv/Dollar.svg'
import DollarSecondary from '../../../../../../media/felsv/DollarSecondary.svg'

import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'

import '../../../../../EmitirFactura/Components/GeneracionFactura/styles/DatosProducto.css'
import DatosProductoSuma from '../../../../../EmitirFactura/Components/GeneracionFactura/DatosProductoSuma'

import { facturacionCloseModalEditar, facturacionFormProductoClear } from '../../../../../../actions/facturacion/facturacionProductos.actions'
import { actionFacturacionProducto } from '../../../../../../actions/action-creators'
import { State } from '../../../../../../reducers'
import { ProductosF } from '../../../../../../interfaces/facturacion.interface'
import InputIcon from '../../../../../../components/Inputs/InputIcon'
import DatosSucursalV1 from '../sucursales/DatosSucursalV1'
import { REGEX_DECIMALES_3DIGITOS } from '../../../../../../constants/Regex'

/* APLICA PARA COMPROBANTE CREDITO FISCAL */

const FormProductosV1 = (props: any) => {
  const formProducto: ProductosF = useSelector((state: State) =>
    props.editar ? state.facturacion.formProductosEdit : state.facturacion.formProductos
  )
  const errors: ProductosF = useSelector((state: State) =>
    props.editar ? state.facturacion.errorsFormProductosEdit : state.facturacion.errorsFormProductos
  )
  const dispatch = useDispatch()
  const acciones = bindActionCreators(actionFacturacionProducto, dispatch)

  useEffect(() => {
    acciones.facturacionFormProductoUpdateCalculo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    formProducto.cantidad,
    formProducto.precio,
    formProducto.descuento,
    formProducto.tipoDescuento,
  ])

  const agregarProducto = (e: any) => {
    e.preventDefault()
    acciones.facturacionFormProductoAddProducto()
  }

  const clear = () => dispatch(facturacionFormProductoClear())
  const closeModal = () => dispatch(facturacionCloseModalEditar())

  const handleNoGravado = () => {
    const nuevoValor = !formProducto.checkNoGravado
    acciones.facturacionFormProductoHandleChangeInput({target: {name: 'checkNoGravado', value: nuevoValor}})
  }

  return (
    <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ecd-0b1e6fa6' className='w-layout-cell'>
      <div className='card w-form'>
        {!props.editar && <DatosSucursalV1 docActual={props.doc} />}
        <form className='form-content' onSubmit={agregarProducto}>
          <div>
            <h3 className='card-title l'>Producto</h3>
          </div>
          <div className='form-separator'></div>
          <div className='label-input'>
            <label className='field-label m'>Tipo de monto</label>
            <div className='div-block'>
              <button
                type='button'
                className={`product-type w-inline-block div-button ${!formProducto.checkNoGravado ? 'product-type-active' : ''}`}
                onClick={() => acciones.facturacionFormProductoHandleChangeInput({target: {name: 'checkNoGravado', value: false}})}
              >
                <div>Gravado</div>
              </button>
              <button
                type='button'
                className={`product-type w-inline-block div-button ${formProducto.checkNoGravado ? 'product-type-active' : ''}`}
                onClick={handleNoGravado}
              >
                <div>No Gravado</div>
              </button>
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='descripcion' className='field-label m'>
                Descripción
              </label>
              <input autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='descripcion'
                data-name=''
                placeholder='Descripción del producto'
                id='descripcion'
                maxLength={1000}
                value={formProducto.descripcion}
                onChange={acciones.facturacionFormProductoHandleChangeInput}
                onBlur={acciones.facturacionFormProductoValidacionesOnBlur}
              />
              {errors.descripcion && <p className='alert s'>{errors.descripcion}</p>}
            </div>
          </div>
          <div className={`ef-form-producto-div4${props.editar ? '-modal' : ''}`}>
            <div className='label-input'>
              <label htmlFor='cantidad' className='field-label m'>
                Cantidad
              </label>
              <input autoComplete='off'
                type='text'
                
                className='m text-field w-input'
                name='cantidad'
                data-name=''
                placeholder='0'
                id='cantidad'
                value={formProducto.cantidad}
                onChange={acciones.facturacionFormProductoHandleChangeInput}
                onBlur={acciones.facturacionFormProductoValidacionesOnBlur}
              />
              {errors.cantidad ? (
                <p className='alert s'>{errors.cantidad}</p>
              ) : errors.precio || errors.tipoDescuento || errors.descuento ? (
                <p className='alert s'>&nbsp;</p>
              ) : (
                ''
              )}
            </div>
            <div className='label-input'>
              <label htmlFor='precio' className='field-label m'>
                Precio
              </label>
              <input autoComplete='off'
                type='text'
                
                className='m text-field w-input'
                name='precio'
                data-name=''
                placeholder='0.00'
                id='precio'
                value={formProducto.precio}
                onChange={acciones.facturacionFormProductoHandleChangeInput}
                onBlur={acciones.facturacionFormProductoValidacionesOnBlur}
              />
              {errors.precio ? (
                <p className='alert s'>{errors.precio}</p>
              ) : errors.cantidad || errors.tipoDescuento || errors.descuento ? (
                <p className='alert s'>&nbsp;</p>
              ) : (
                ''
              )}
            </div>
            <div className='label-input'>
              <label htmlFor='tipoDescuento' className='field-label m'>
                Tipo de desc.
              </label>
              <select
                id='tipoDescuento'
                name='tipoDescuento'
                data-name=''
                className='m text-field w-select'
                value={formProducto.tipoDescuento}
                onChange={acciones.facturacionFormProductoHandleChangeInput}
                onBlur={acciones.facturacionFormProductoValidacionesOnBlur}
              >
                <option value='porcentaje'>Porcentaje</option>
                <option value='monto'>Monto</option>
              </select>
              {errors.tipoDescuento ? (
                <p className='alert s'>{errors.tipoDescuento}</p>
              ) : errors.cantidad || errors.precio || errors.descuento ? (
                <p className='alert s'>&nbsp;</p>
              ) : (
                ''
              )}
            </div>
            <div className='label-input'>
              <label htmlFor='descuento' className='field-label m'>
                Descuento
              </label>
              <InputIcon
                darkIcon={formProducto.tipoDescuento === 'porcentaje' ? DarkPorcentaje : DarkDollar}
                secondaryIcon={
                  formProducto.tipoDescuento === 'porcentaje'
                    ? SecondaryPorcentaje
                    : DollarSecondary
                }
                type='text'
                
                className={`text-field-icon2 ${
                  formProducto.tipoDescuento === 'porcentaje' ? 'porcentaje' : 'dollar'
                } w-input`}
                name='descuento'
                data-name=''
                placeholder='0.00'
                id='descuento'
                value={formProducto.descuento}
                onChange={acciones.facturacionFormProductoHandleChangeInput}
                onBlur={acciones.facturacionFormProductoValidacionesOnBlur}
              />
              {errors.descuento ? (
                <p className='alert s'>{errors.descuento}</p>
              ) : errors.cantidad || errors.precio || errors.tipoDescuento ? (
                <p className='alert s'>&nbsp;</p>
              ) : (
                ''
              )}
            </div>
          </div>

          <div className='form-separator'></div>
          <DatosProductoSuma
            subtotal={formProducto.subtotal?.replace(REGEX_DECIMALES_3DIGITOS, '$&,')}
            descuento={formProducto.cantidadDescuento?.replace(REGEX_DECIMALES_3DIGITOS, '$&,')}
            impuesto={formProducto.totalImpuesto1?.replace(REGEX_DECIMALES_3DIGITOS, '$&,')}
            total={formProducto.total?.replace(REGEX_DECIMALES_3DIGITOS, '$&,')}
          />

          {props.editar ? (
            <div className='w-layout-hflex button-actions'>
              <div style={{width: '70%'}}></div>
              <button
                type='button'
                className='m button transparent botton-footer'
                onClick={closeModal}
              >
                <div>Cancelar</div>
              </button>
              <button type='submit' className='m button botton-footer'>
                <div>Actualizar</div>
                <img src={WhiteCheck} loading='lazy' alt='Generar' />
              </button>
            </div>
          ) : (
            <div className='w-layout-hflex button-actions'>
              <button type='button' className='m button transparent w-inline-block' onClick={clear}>
                <div>Limpiar</div>
              </button>
              <button type='submit' className='m button w-inline-block'>
                <img src={WhitePlus} loading='lazy' alt='Agregar' />
                <div>Agregar</div>
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  )
}

export default FormProductosV1
